import { render, staticRenderFns } from "./perfect.vue?vue&type=template&id=66c430fd&"
import script from "./perfect.vue?vue&type=script&lang=js&"
export * from "./perfect.vue?vue&type=script&lang=js&"
import style0 from "./perfect.vue?vue&type=style&index=0&id=66c430fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports